import { PRIMITIVE_TEXT_CATALOG } from "@/v2-ui/text/offline/catalog"
import { makeOfflineText } from "@/v2-text/offline/makeOfflineText"

/**
 * Reader for v2-ui's own `Primitive` pool (`UI_Primitive_*`). See
 * `@/v2-text/offline/makeOfflineText` for the factory that backs this hook
 * and for the matching sync variants (`getPrimitiveTextSync`,
 * `interpolatePrimitiveTextSync`) used by non-React callers.
 *
 * `{ getText }` mirrors the DB text hooks so call sites read identically
 * (`getText(key).Name`), but there is no fetch, no loading state, and no
 * provider requirement — primitives that render outside the console's
 * `<TextProvider>` (login, error boundaries, Storybook, tests, other apps)
 * consume this hook.
 */
export const {
  useOfflineText: usePrimitiveText,
  getTextSync: getPrimitiveTextSync,
  interpolateSync: interpolatePrimitiveTextSync,
} = makeOfflineText(PRIMITIVE_TEXT_CATALOG)
